import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let current_location_xid = useDataValue({
    context: 'global',
    path: 'current_location.xid',
    viewPath: props.viewPath,
  })

  return {
    variables: { current_location_xid },
    requestPolicy: 'network-only',
  }
}
